import type { ComponentProps, JSX, PropsWithChildren } from 'react';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import type { IconComponent } from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

type Props = {
	icon: IconComponent;
	iconColor: string;
	background?: string;
	headingColor?: string;
	customStyles?: ComponentProps<typeof Box>['sx'];
};

export function SidePetitionStatus({
	icon,
	iconColor,
	children,
	headingColor,
	background,
	customStyles,
}: PropsWithChildren<Props>): JSX.Element {
	return (
		<Box
			p={8}
			mt={8}
			mb={24}
			// eslint-disable-next-line @typescript-eslint/no-misused-spread
			sx={{ textAlign: 'center', background, borderRadius: '8px', ...(customStyles ?? {}) }}
		>
			<Heading as="h3" size={['h4', 'h3']} color={headingColor}>
				<Box sx={{ position: 'relative', display: 'inline-block', bottom: -2 }} mr={8}>
					<Icon icon={icon} size="xl" color={iconColor} />
				</Box>
				{children}
			</Heading>
		</Box>
	);
}
